import React, { ChangeEvent } from 'react';
import { FileUploader, Input } from '@cokitchen/cokitchen-components';
import SelectDropdown from 'components/base/select-dropdown';
import { FILE_UPLOADER_TOKEN } from 'utils/constants';
import useDashboardContext from 'contexts/dashboard.context';
import { AddStoreType } from 'models/store.model';

const BasicStoreDetails = ({
  form,
  sendValues
}: {
  form: AddStoreType;
  sendValues: (arg0: any) => void;
}) => {
  const { cokitchens } = useDashboardContext();

  const updateForm = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    sendValues({ [name]: value });
  };
  return (
    <div>
      <div className='bg-white rounded-lg  w-full'>
        <div className='mb-8'>
          <p className='font-semibold text-xl'>Store details</p>
          <p className='text-gray-9 text-sm'>Kindly provide the details to create a new store </p>
        </div>
        <div className='w-full flex gap-4 mb-4'>
          <Input
            className='w-full'
            design='bordered'
            label={'Name of store'}
            name='name'
            placeholder={'Enter name of store'}
            value={form?.name}
            onChange={(val) => updateForm(val)}
          />
          <div className='w-full'>
            <SelectDropdown
              label='Type of store'
              placeholder='Select store type'
              value={form?.type}
              setValue={(val) => sendValues({ type: val?.id })}
              options={[
                { id: 'Bakery', name: 'Bakery' },
                { id: 'Juice', name: 'Juice' },
                { id: 'Cokitchen', name: 'Cokitchen' }
              ]}
            />
          </div>
        </div>
      </div>

      <SelectDropdown
        label='Location'
        placeholder='Select cokitchen location'
        value={form.location}
        setValue={(val) => sendValues({ location: val?.id })}
        options={cokitchens?.map(({ name }) => {
          return { name: name, id: name };
        })}
      />

      <div className='space-y-2 mt-4'>
        <label>Store logo</label>
        <FileUploader
          fileUrls={form.logo ? [form.logo] : []}
          setFileUrls={(imageUrls: any) => {
            sendValues({ logo: imageUrls[0] });
          }}
          token={FILE_UPLOADER_TOKEN}
          className='w-full border-none p-0 m-0'
          maxFileSize={10 * 1024 * 1024} // 10 MB in bytes
        />
      </div>
    </div>
  );
};

export default BasicStoreDetails;
